module.exports = __webpack_public_path__ + "static/media/8.7bfb99a5.webm";